export default __webpack_public_path__ + "static/media/mexico-city.30c7cebc.png";